{
  "version": 1,
  "asset_id": "64b72cda-d0f0-4842-8837-b5c42ca7de0a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/64b72cda-d0f0-4842-8837-b5c42ca7de0a/sleeve-fitzer-3.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/64b72cda-d0f0-4842-8837-b5c42ca7de0a/sleeve-fitzer-3.webp",
  "original_filename": "sleeve-fitzer-3.webp",
  "size": 18310,
  "content_type": "image/webp",
  "created_at": "2026-08-15T18:29:21Z"
}
